import {IconMap, IconPath} from '@shared/common/icons';
import {hasValue} from "@shared/utils/helpers";

export class Alert {
  id: string;
  type: AlertType;
  title: string;
  desc?: string;
  autoClose?: number;
  keepAfterRouteChange: boolean;
  fade: boolean;
  // For Live alerts, define a callback that MUST be invoked to dismiss
  mandatoryDismiss?: () => void;

  constructor(init?: Partial<Alert>) {
    Object.assign(this, init);

    // For non-live alerts, default autoClose to 7.5s if not specified
    if (this.type !== AlertType.Live && !this.autoClose) {
      this.autoClose = 7500;
    }

    if (!hasValue(this.id)) {
      this.id = new Date().getTime().toString();
    }
  }

  get icon(): IconPath {
    switch (this.type) {
      case AlertType.Info:
      case AlertType.Error:
      case AlertType.Success:
      case AlertType.Warning:
        return IconMap.information;
      // (Optional) Return a different icon for Live alerts
      // case AlertType.Live:
      //   return IconMap.loading;
    }
  }
}


export enum AlertType {
  Success,
  Error,
  Info,
  Warning,
  Live // New type for progress/loading alerts
}
